import React, { useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useJiraIntegrationPage } from '../../jira-integration-page.provider'
import { transformFormDataToBugtrackerRequest } from '../../../../bugtrackers/api/build-api-payload-bugtracker-credentials'
import { JiraFieldDefaultValueProps } from '../jira-field-default-value'
import { MultiSelectCombobox } from '../../../../../../legacy-design-system/combobox'
import { useJiraLabelsQuery } from '../../../api/use-jira-label-query'
import { JiraIntegrationForm } from '../../jira-form-schema'

export const LabelsField = (props: JiraFieldDefaultValueProps) => {
  const { field, updateValue } = props
  const [search, setSearch] = useState<string>('')
  const { getValues } = useFormContext<JiraIntegrationForm>()

  const initialAllowedValues = useMemo(
    () =>
      field._projectField?.allowedValues?.map(
        (allowedValue) => allowedValue.id
      ) ?? [],
    [field._projectField?.allowedValues]
  )

  const [allowedValues, setAllowedValues] =
    useState<string[]>(initialAllowedValues)

  const selectedValues = !field.value?.trim().length
    ? []
    : field.value?.split(',')

  const {
    state: { organizationUuid }
  } = useJiraIntegrationPage()

  const { labels } = useJiraLabelsQuery({
    organizationUuid,
    bugtrackerRequest: transformFormDataToBugtrackerRequest(getValues),
    search
  })

  useEffect(() => {
    if (labels) {
      setAllowedValues(search ? labels : initialAllowedValues)
    }
  }, [labels, search, initialAllowedValues])

  const onSelectionChange = (event) => updateValue(event.join(','))
  const onSearchChange = (event) => setSearch(event)
  const onDropdownVisibilityChanged = () => setSearch('')

  return (
    <MultiSelectCombobox
      items={[
        {
          items: allowedValues ?? []
        }
      ]}
      label=""
      onChange={onSelectionChange}
      renderLabel={() => undefined}
      values={selectedValues}
      onSearchChange={onSearchChange}
      onDropdownVisibilityChanged={onDropdownVisibilityChanged}
    />
  )
}
